/* =========================================================
   SIBICURA — Global JS Hooks (Phase 1 Stub)
   Wird in Phase 2 mit Hero-Video-Pause, Sticky-Cart, Cart-Drawer ausgebaut.
   ========================================================= */

(function () {
  'use strict';

  // Live-Cart-Counter aktualisieren, wenn Shopify cart-update events feuert.
  document.addEventListener('cart:updated', function (event) {
    var count = (event && event.detail && event.detail.cart && event.detail.cart.item_count) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  });

  // Reduzierte Bewegung respektieren (für Phase-2-Video).
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('prefers-reduced-motion');
  }
})();
